package org.vreo.devicehub.di

import org.koin.core.context.startKoin
import org.koin.dsl.KoinAppDeclaration

/**
 * Initialize Koin DI.
 */
fun initKoin(config: KoinAppDeclaration? = null) {
    startKoin {
        config?.invoke(this)
        modules(
            platformHttpModule,
            globalAppModules,
        )
        createEagerInstances()
        allowOverride(true)
    }
}